/**
 * Cart price/total formatting — verbatim from v1 process_cart_page.js
 * (research/05 §5.4, §8.16; REQ-CART-5). CARTPAGE_getCurrency's table is kept
 * verbatim including the identical OMR branches, the MAD suffix-flag ignore,
 * and CARTPAGE_formatPrice's always-trailing-space format. `updatePrice`
 * writes formatted prices/totals into the legacy `<cpc …>` targets via the
 * BUNDLED jQuery (DIV-004; v1 used the theme's).
 */
import { appState } from "../state/app-state";
import { formatPricing } from "../pricing";
import $ from "jquery";

export function CARTPAGE_formatPrice(currencyCode: any, amount: any, isTotalField?: any): string {
  let amountFormated = Number(amount).toFixed(2);
  let cpc_CurrencySymbol = CARTPAGE_getCurrency(currencyCode, isTotalField);

  return (
    cpc_CurrencySymbol.before +
    formatPricing(
      Number(amountFormated),
      +appState.cpc_configData.thousandSeperator,
      +appState.cpc_configData.decimalSeperator,
      true,
    ) +
    " " +
    cpc_CurrencySymbol.after
  );
}

export function updatePrice(selector: any, currencyCode: any, amount: any, isTotalField: any, wrapInSpan: any): void {
  // Format the price using existing function
  var formattedPrice = CARTPAGE_formatPrice(currencyCode, amount, isTotalField);

  // Conditionally wrap the price in <span class="money">
  if (wrapInSpan) {
    formattedPrice = '<span class="money">' + formattedPrice + "</span>";
  }

  // Update the HTML content
  $(selector).html(formattedPrice);
}

export function CARTPAGE_getCurrency(currencyCode: any, isTotalField = false): { before: string; after: string } {
  var currencyCodeUpperCase = currencyCode.toUpperCase();
  let shouldIncludeCurrencySuffix = isTotalField && appState.cpc_fasterCheckoutConfig.checkoutConfig?.includeCurrencySuffix === true;

  switch (currencyCodeUpperCase) {
    case "USD":
      return { before: "$", after: shouldIncludeCurrencySuffix ? currencyCodeUpperCase : "" };
    case "CAD":
      return {
        before: "$",
        after: shouldIncludeCurrencySuffix ? currencyCodeUpperCase : "CAD",
      };
    case "DKK":
      return { before: "", after: shouldIncludeCurrencySuffix ? currencyCodeUpperCase : "KR" };
    case "GBP":
      return {
        before: "&pound;",
        after: shouldIncludeCurrencySuffix ? currencyCodeUpperCase : "",
      };
    case "AUD":
      return {
        before: "$",
        after: shouldIncludeCurrencySuffix ? currencyCodeUpperCase : "AUD",
      };
    case "BRL":
      return { before: "R$", after: shouldIncludeCurrencySuffix ? currencyCodeUpperCase : "" };
    case "ZAR":
      return { before: "R", after: shouldIncludeCurrencySuffix ? currencyCodeUpperCase : "" };
    case "SGD":
      return { before: "$", after: shouldIncludeCurrencySuffix ? currencyCodeUpperCase : "" };
    case "EUR":
      return {
        before: "&euro;",
        after: shouldIncludeCurrencySuffix ? currencyCodeUpperCase : "",
      };
    case "MAD":
      return { before: "", after: "dh" };
    case "OMR":
      return {
        before: "",
        after: shouldIncludeCurrencySuffix ? currencyCodeUpperCase : currencyCodeUpperCase,
      };
    case "TRY":
      return {
        before: "",
        after: shouldIncludeCurrencySuffix ? currencyCodeUpperCase : "&#8378;",
      };
    case "CLP":
      return { before: "$", after: "" };
    case "IDR":
      return { before: "RP", after: "" };
    case "MXN":
      return { before: "$", after: "" };
    case "MYR":
      return { before: "RM ", after: "" };
    default:
      return { before: "", after: currencyCode.toUpperCase() };
  }
}
